// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2w-FU","primary":"styles_primary__27egH","secondary":"styles_secondary__179nc"};